export const initialEasyPzTransformParams = {
  scale: 1,
  translateX: 0,
  translateY: 0
}

export const localStorageBuilding = 'BUILDING'
